const QcIconSuccess = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='36'
      viewBox='0 0 48 36'
      fill='none'
    >
      <g clipPath='url(#clip0_10375_284266)'>
        <path
          d='M47.9997 0H17.2803V2.4427C22.5735 4.16142 26.4001 9.1339 26.4001 15.0001C26.4001 20.8664 22.5735 25.8389 17.2803 27.5576V36.0003H47.9997V0Z'
          fill='#EBFEF4'
        />
        <path
          d='M26.3475 16.1832C26.3821 15.7935 26.3998 15.3986 26.3998 15.0001C26.3998 14.1816 26.3248 13.3777 26.1821 12.6001H43.1998V16.2002H26.346C26.3465 16.1943 26.3471 16.189 26.3475 16.1832Z'
          fill='#D0FBE2'
        />
        <path
          d='M25.5001 19.8002C24.9869 21.1133 24.2684 22.3274 23.3857 23.3967L23.3828 23.4002H40.7999V19.8002H25.5001Z'
          fill='#D0FBE2'
        />
        <path
          d='M24.9605 9.00009H43.1999V6.00006H22.856C23.6863 6.89069 24.3956 7.89676 24.9559 8.99071C24.9575 8.99364 24.9589 8.99716 24.9605 9.00009Z'
          fill='#D0FBE2'
        />
        <path
          d='M22.7998 26.4002H34.7998V30.0003H22.7998V26.4002Z'
          fill='#D0FBE2'
        />
        <path
          d='M11.3999 24.5002C6.15305 24.5002 1.8999 20.2471 1.8999 15.0002C1.8999 9.75325 6.15305 5.50006 11.3999 5.50006C16.6468 5.50006 20.8999 9.75325 20.8999 15.0002C20.8999 20.2471 16.6468 24.5002 11.3999 24.5002ZM11.3999 22.6002C13.4155 22.6002 15.3486 21.7995 16.7739 20.3742C18.1992 18.9489 18.9999 17.0158 18.9999 15.0002C18.9999 12.9845 18.1992 11.0514 16.7739 9.62609C15.3486 8.2008 13.4155 7.40008 11.3999 7.40008C9.38426 7.40008 7.45117 8.2008 6.02589 9.62609C4.60061 11.0514 3.7999 12.9845 3.7999 15.0002C3.7999 17.0158 4.60061 18.9489 6.02589 20.3742C7.45117 21.7995 9.38426 22.6002 11.3999 22.6002ZM10.4528 18.8002L6.4219 14.7693L7.7652 13.426L10.4528 16.1136L15.826 10.7394L17.1702 12.0827L10.4528 18.8002Z'
          fill='#009B5F'
        />
      </g>
      <defs>
        <clipPath id='clip0_10375_284266'>
          <rect width='48' height='36' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

QcIconSuccess.displayName = 'QcIconSuccess';

export default QcIconSuccess;
